'use strict';

frontendApp.controller('AddCustodianModalCtrl', ['$scope', '$http', '$uibModalInstance', 'project', 'ConfigService', 'CustodianService', 'NotificationService', function ($scope, $http, $uibModalInstance, project, ConfigService, CustodianService, NotificationService) {

    $scope.project = project;

    $scope.saving = false;
    $scope.signUpSuccess = false;

    $scope.close = function () {
        if ($scope.saving) return;
        $uibModalInstance.close();
    };

    $scope.saveCustodian = function (custodian) {

        $scope.saving = true;

        var newCustodian = CustodianService.Create(project.id, custodian.name);
        CustodianService.Save(newCustodian, function (custodian) {

            $scope.saving = false;
            $scope.custodians.push(custodian);
            $scope.close();

            NotificationService.addSuccess({
                title: 'Custodian added succesfully',
                description: 'Name: ' + custodian.name,
                timeout: 5000
            });

        }, function (data) {
            $scope.saving = false;
        });

    };


}]);
    
